import HttpClient from '@/common/boot/HttpClient'

const listarTratativasOpcoes = async ({ commit }, payload) => {
  await HttpClient.get('/gestao-producao/ctrl-tratativas-opcoes', payload).then(response => {
      commit('LISTAR_TRATATIVAS_OPCOES', response.data.data);
      return response;
  }).finally( () => {

  });
}

const listarRestoreTratativasOpcoes = ({commit}, payload) => {
  commit('BUSCANDO', true);

  let params =  {params: { trashed: payload}};

  HttpClient.get('/gestao-producao/ctrl-tratativas-opcoes', {
      params
  }).then(response => {
      commit('LISTAR_TRATATIVAS_OPCOES', response.data.data)
      return response;
  }).finally(() => {
      commit('BUSCANDO', false)
  });

  return true
}


const excluirTratativasOpcoes = async ({ commit, dispatch },  payload) => { 
  commit('BUSCANDO', true);
    let qtdRows = payload.length;
    for(let i=0;i<qtdRows;++i){
      await excluir(payload[i]);
    }
   
    await dispatch('listarTratativasOpcoes');

    commit('BUSCANDO', false);
}  

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/gestao-producao/ctrl-tratativas-opcoes/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarTratativaOpcao = async ({ commit,dispatch }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.post('/gestao-producao/ctrl-tratativas-opcoes', payload).then(async response => {
    await dispatch('listarTratativasOpcoes');
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

const recuperarTratativaOpcao = ({ commit, state }, payload) => {

  commit('BUSCANDO', true);

  const item = state.items.filter(item => item.id === payload.id);

  if(item.length) {
    commit('INSERIR_TRATATIVA_OPCAO_SELECIONADO', ...item);
    return true;
  }

  commit('BUSCANDO', false);

  return false;
}

const atualizarTratativaOpcao = async ({ commit,dispatch }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.put(`/gestao-producao/ctrl-tratativas-opcoes/${payload.id}`, payload).then(response => {
    dispatch('listarTratativasOpcoes');
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const restaurarTratativaOpcao = ({ commit, dispatch }, payload) => {

  commit('BUSCANDO', true);

  HttpClient.get(`/gestao-producao/ctrl-tratativas-opcoes/restaurar/${payload}`).then(response => {
      commit('ATUALIZAR_TRATATIVAS_OPCOES', response.data.data)
      dispatch('listarTratativasOpcoes')
      return response;
  }).finally(() => {
      commit('BUSCANDO', false);
  });

}

export {
  listarTratativasOpcoes,
  listarRestoreTratativasOpcoes,
  excluirTratativasOpcoes,
  salvarTratativaOpcao,
  recuperarTratativaOpcao,
  atualizarTratativaOpcao,
  restaurarTratativaOpcao
}